// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tf-0";